"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var bannerThemefication = function bannerThemefication(theme, status) {
  var themes = {
    danger: {
      backgroundColor: theme.colors['danger04'],
      iconBackgroundColor: theme.colors['danger03'],
      borderColor: theme.colors['danger02']
    },
    info: {
      backgroundColor: theme.colors['info04'],
      iconBackgroundColor: theme.colors['info03'],
      borderColor: theme.colors['info02']
    },
    warning: {
      backgroundColor: theme.colors['warning04'],
      iconBackgroundColor: theme.colors['warning03'],
      borderColor: theme.colors['warning02']
    },
    success: {
      backgroundColor: theme.colors['success04'],
      iconBackgroundColor: theme.colors['success03'],
      borderColor: theme.colors['success02']
    }
  };
  return themes[status];
};

var _default = bannerThemefication;
exports.default = _default;